<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg8>
          <v-card class="elevation-2" v-if="transactionObj">
            <v-card-title v-if="transactionObj">{{transactionObj.status}}</v-card-title>
            <app-loading v-else></app-loading>
            <app-loading v-if="transactionObj.status=== 'Pending'"></app-loading>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
import {doc, onSnapshot, updateDoc} from "firebase/firestore";
// import dispatch from "@/components/orders/dispatch";
export default {
  props: ['transactionId'],
  data: () => ({
    transactionObj: null,
    orderData: null,
    stripeObj: null
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    let db = this.$store.state.db
    let uid = this.user.uid
    let orderRef = doc(db, 'users', uid + '/cardPayments/stripe/charges/' + this.transactionId)
    onSnapshot(orderRef, res => {
      // console.log(res)
      if(res.exists) {
        let data = res.data()
        this.transactionObj = data
        this.orderData = data.orderData
        if (data.status === 'Payment Made') {
          //chane payment split status
          if (data.paymentInfo.splitTitle === 'Remaining Balance') {
            this.orderData.remainingBalanceStatus = 'Paid'
          }
          else {
            let orderSplit = this.orderData.payments.find(split => {
              return split.created === data.paymentInfo.created
            })
            let paymentIndex = this.orderData.payments.indexOf(orderSplit)
            this.orderData.payments[paymentIndex].status = 'Paid'
          }
          //update order status
          let progress = {
            type: 'paymentMade',
            method: 'payment',
            invoice: data.invoiceObj,
            title: data.paymentInfo.splitTitle + ' paid',
            created: Date.now()
          }
          if (this.orderData.progress) {
            this.orderData.progress.push(progress)
            this.updateOrder()
          } else {
            this.orderData.progress = [progress]
            this.updateOrder()
          }
          this.$store.dispatch('setLoading', false)
          //console.log(this.orderData)
          this.$store.dispatch('resetTransaction')
          this.$router.push('/booking/' + data.orderData.id)
        }
      }
    })
  },
  methods: {
    updateOrder() {
      let db = this.$store.state.db
      let orderRef = doc(db, 'users', this.user.uid + '/orders/' + this.orderData.id)
      // console.log(this.orderData)
      updateDoc(orderRef, this.orderData)
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

